import $ from "jquery";
import Swiper from "swiper/swiper-bundle.js";
import lightGallery from "lightgallery";

const prev_next_upsells = $(
  ".upsells .swiper-button-next, .upsells .swiper-button-prev"
);
const prev_next_related = $(
  ".related .swiper-button-next, .related .swiper-button-prev"
);

const create_lightbox = (container, swiper_slide) => {
  const swiperContainers = document.querySelector("." + container);
  const gsBgImgSelector = "." + swiper_slide + " img";

  const dynamicEl = [...swiperContainers.querySelectorAll(gsBgImgSelector)].map(
    (sliderImg) => {
      return {
        src: sliderImg.getAttribute("srcset"),
        srcset: sliderImg.getAttribute("srcset"),
        thumb: sliderImg.getAttribute("srcset"),
        subHtml: sliderImg.alt,
      };
    }
  );
  const dynamicGallery = swiperContainers;
  const popup = lightGallery(dynamicGallery, {
    dynamic: true,
    loop: true,
    autoplayVideoOnSlide: true,
    dynamicEl,
  });
  dynamicGallery.addEventListener("click", () => {
    popup.openGallery(0);
  });
  [...swiperContainers.querySelectorAll(".swiper-slide")].map((slide, idx) => {
    slide.addEventListener("click", () => {
      popup.openGallery(idx);
    });
  });
};

const wall_padding_swiper = new Swiper(".swiper-padding0", {
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination0",
    clickable: true,
  },
});

const wall_padding_swiper1 = new Swiper(".swiper-padding1", {
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination1",
    clickable: true,
  },
});

const wall_padding_swiper3 = new Swiper(".swiper-padding2", {
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination2",
    clickable: true,
  },
});
const wall_padding_swiper4 = new Swiper(".swiper-padding3", {
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination3",
    clickable: true,
  },
});

if ($(".image-wrapper-wall-padding0").length !== 0) {
  create_lightbox("image-wrapper-wall-padding0", "wall-slide0");
  create_lightbox("image-wrapper-wall-padding1", "wall-slide1");
  create_lightbox("image-wrapper-wall-padding2", "wall-slide2");
  create_lightbox("image-wrapper-wall-padding3", "wall-slide3");
}

const top_products_swiper = new Swiper(".swiper-top-products", {
  slidesPerView: 4.5,
  spaceBetween: 20,
  freeMode: true,
  watchOverflow: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1600: {
      slidesPerView: 4.5,
    },
    1330: {
      slidesPerView: 3.5,
    },
    900: {
      slidesPerView: 2.5,
    },
    750: {
      slidesPerView: 2.5,
    },
    480: {
      spaceBetween: 20,
      slidesPerView: 1.2,
    },
    400: {
      spaceBetween: 20,
      slidesPerView: 2,
    },
    100: {
      spaceBetween: 20,
      slidesPerView: 1.5,
    },
  },
});
const upsell_products_swiper = new Swiper(".upsells .swiper-top-products", {
  slidesPerView: 4.5,
  spaceBetween: 20,
  freeMode: true,
  watchOverflow: true,
  navigation: {
    nextEl: ".swiper-upsell-button-next",
    prevEl: ".swiper-upsell-button-prev",
  },
  breakpoints: {
    1600: {
      slidesPerView: 4.5,
    },
    1330: {
      slidesPerView: 3.5,
    },
    900: {
      slidesPerView: 2.5,
    },
    750: {
      slidesPerView: 2.5,
    },
    480: {
      spaceBetween: 20,
      slidesPerView: 1.2,
    },
    400: {
      spaceBetween: 20,
      slidesPerView: 2,
    },
    100: {
      spaceBetween: 20,
      slidesPerView: 1.5,
    },
  },
});

const color_swatches_swiper = new Swiper(".swiper-color-swatches", {
  slidesPerView: 6,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    985: {
      slidesPerView: 6,
    },
    735: {
      slidesPerView: 4,
    },
    500: {
      slidesPerView: 3,
    },
    400: {
      slidesPerView: 2,
    },
    300: {
      slidesPerView: 1,
    },
  },
});

const card_swiper = new Swiper('.cards-section--slider', {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  direction: "horizontal",
  autoHeight: true,
  navigation: {
    nextEl: ".cards-section-swiper-button-next",
    prevEl: ".cards-section-swiper-button-prev",
  },
  breakpoints: {
    700: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1276:{
      slidesPerView: 4,
      spaceBetween: 16,
    }
  }
});

const home_swiper = new Swiper(".mySwiper", {
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  loop: true,
  autoHeight: true,
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true,
  },
});

if ($(".swiper-expand-icon").length !== 0) {
  document.querySelectorAll(".swiper-expand-icon").forEach((element) => {
    element.addEventListener("click", () => {
      let parent_element = element.parentElement;
      console.log(parent_element.className);
      parent_element.querySelector(".swiper-slide-active").click();
    });
  });
}

if ($(".single-product-expand-icon").length !== 0) {
  document
    .querySelector(".single-product-expand-icon")
    .addEventListener("click", () => {
      document.querySelector(".flex-active-slide a").click();
    });
}

function hide_show_arrows(arrows, prev_next) {
  if (arrows.length === 2) {
    arrows.each(function () {
      $(this).css("visibility", "hidden");
    });
  } else {
    prev_next.each(function () {
      $(this).css("visibility", "visible");
    });
  }
}

$(window).on("load resize", () => {
  let upsell_arrows = $(".upsells .swiper-button-disabled");
  let related_arrows = $(".related .swiper-button-disabled");
  hide_show_arrows(upsell_arrows, prev_next_upsells);
  hide_show_arrows(related_arrows, prev_next_related);
});
